export default __webpack_public_path__ + "static/media/ne.cd10fef7.png";